import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, ChevronLeft, ChevronRight } from 'lucide-react';

interface Props { agencies: any[]; }

export function MobileAgenciesRow({ agencies }: Props) {
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);

  if (!agencies?.length) return null;

  const scroll = (dir: 'left' | 'right') => {
    if (!ref.current) return;
    const w = ref.current.clientWidth * 0.5;
    ref.current.scrollBy({ left: dir === 'left' ? -w : w, behavior: 'smooth' });
  };

  return (
    <section className="container py-6 md:hidden">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display text-lg font-bold">Top Agencies</h2>
        <button onClick={() => navigate('/agencies')} className="text-xs font-semibold text-primary">View All</button>
      </div>
      <div className="relative">
        <button
          onClick={() => scroll('left')}
          aria-label="Scroll agencies left"
          className="absolute -left-2 top-1/2 -translate-y-1/2 z-10 h-8 w-8 rounded-full bg-background/90 border shadow flex items-center justify-center"
        >
          <ChevronLeft className="h-4 w-4 text-primary" />
        </button>
        <button
          onClick={() => scroll('right')}
          aria-label="Scroll agencies right"
          className="absolute -right-2 top-1/2 -translate-y-1/2 z-10 h-8 w-8 rounded-full bg-background/90 border shadow flex items-center justify-center"
        >
          <ChevronRight className="h-4 w-4 text-primary" />
        </button>
        <div ref={ref} className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory scroll-smooth pb-2">
          {agencies.map(a => (
            <button
              key={a.id}
              onClick={() => navigate(`/agencies/${a.slug || a.id}`)}
              className="snap-start shrink-0 basis-[calc(50%-6px)] rounded-xl border bg-card p-3 text-left hover:shadow-md transition"
            >
              <div className="aspect-square rounded-lg bg-muted flex items-center justify-center overflow-hidden mb-2">
                {a.logo_url ? (
                  <img src={a.logo_url} alt={a.name} loading="lazy" className="w-full h-full object-cover" />
                ) : (
                  <Building2 className="h-8 w-8 text-muted-foreground" />
                )}
              </div>
              <div className="font-semibold text-sm truncate">{a.name}</div>
              <div className="text-[11px] text-muted-foreground truncate">{a.city || 'Ethiopia'}</div>
              <div className="mt-2 text-[11px] font-semibold text-primary">View Listings →</div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
